import { useNewPurchaseOrderVendorsInfiniteQuery } from "./useNewPurchaseOrderVendorsInfiniteQuery";

/**
 * Vendor list for PO screens — infinite scroll with optional pinned selected vendor.
 * `data` is a flat vendor array for backward compatibility with existing callers.
 */
export function useNewPurchaseOrderVendorsQuery({
  merchantId,
  auth,
  search = "",
  ensureVendorId = "",
  enabled = true,
}) {
  const result = useNewPurchaseOrderVendorsInfiniteQuery({
    merchantId,
    auth,
    search,
    ensureVendorId,
    enabled,
  });

  return {
    ...result.query,
    data: result.vendors,
    vendors: result.vendors,
    loadMore: result.loadMore,
    hasMore: result.hasMore,
    isFetchingNextPage: result.isFetchingNextPage,
    isPending: result.isPending,
    error: result.error,
  };
}
